const styles = theme => ({
  fetchUserDetailsHolder: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-start',
    gap: '16px',
    [theme.breakpoints.down('xs')]: {
      flexWrap: 'wrap',
    },
  },

  fetchDetailsInputContainer: {
    flex: 1,
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
  },

  fetchDetailsBtn: {
    backgroundColor: theme.palette.primary.adgmBlack,
    borderColor: theme.palette.primary.adgmBlack,
    color: theme.palette.primary.white,
    padding: '16px 40px',
    marginBottom: '18px',

    [theme.breakpoints.down('xs')]: {
      width: '100%',
      marginBottom: 0,
    },

    '&:hover': {
      backgroundColor: theme.palette.primary.adgmBlack,
      color: theme.palette.primary.white,
    },
    '&:focus': {
      backgroundColor: theme.palette.primary.adgmBlack,
      color: theme.palette.primary.white,
    },

    '& span': {
      fontSize: '16px',
      fontWeight: 600,
      lineHeight: '24px',
      textTransform: 'capitalize',
    },
  },

  details: {
    marginTop: '24px',
    [theme.breakpoints.down('sm')]: {
      marginTop: '16px',
    },
  },

  detailsContent: {
    padding: 0,
  },

  divider: {
    margin: '24px 0',
    [theme.breakpoints.down('sm')]: {
      margin: '16px 0',
    },
  },

  addForAllHolder: {
    marginTop: '24px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },

  addForAllCheckbox: {
    padding: 0,
    margin: 0,
  },

  addForAllChecked: {
    color: `${theme.palette.primary.adgmGreenDark} !important`,
  },

  addForAllText: {
    color: theme.palette.primary.adgmBlack,
    fontSize: '16px',
    fontWeight: 400,
  },
});

export default styles;
